//import React from "react"
import firebase from 'firebase';

export class DeleteService {
  deleteOne = (resource, params) => {
    console.log('deleteOne', resource, params);
    return firebase
      .database()
      .ref(resource)
      .child(params.id)
      .remove()
      .then(_ => {
        const deletedMission = params.previousData;

        if (resource === 'missions') {
          const { contributions } = deletedMission;
          let userIds = [];
          contributions &&
            Object.entries(contributions).map(entry =>
              userIds.push(entry[1].userId)
            );

          userIds.length > 0 &&
            firebase
              .database()
              .ref('users')
              .once('value')
              .then(snapshot => {
                let allUsers = Object.entries(snapshot.val()).map(user =>
                  Object.assign({}, { id: user[0] }, user[1])
                );

                let selectedUsers = allUsers.filter(user =>
                  userIds.includes(user.id)
                );

                return selectedUsers.map(user => {
                  user.missionIds = user.missionIds.filter(
                    missionId => missionId !== deletedMission.id
                  );
                  let { id, ...updatedUser } = user;
                  return firebase
                    .database()
                    .ref(`users/${id}`)
                    .update(updatedUser);
                });
              });
        }

        return { data: deletedMission };
      });
  };

  deleteMany = (resource, params) => {
    console.log('deleteMany', resource, params);
  };
}



// WEBPACK FOOTER //
// ./src/services/DeleteService.js